/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const storeFinder = {
  storeFinder: {
    openUntil: 'Abierto hasta',
    closed: 'Cerrado',
    back: 'Atrás',
    call: 'Llamar',
    getDirections: 'Obtener direcciones',
    ariaLabelGetDirections: 'Obtener direcciones, este enlace se abre en una ventana nueva',
    ariaLabelCountriesCount: 'Tiendas en {{ count }} países encontrados',
    listView: 'Vista de lista',
    mapView: 'Vista de mapa',
    noStoresFound: 'No se han encontrado tiendas.',
    storeHours: 'Horario de la tienda',
    storeFeatures: 'Características de la tienda',
    storeFinder: 'Buscador de tiendas',
    storesFound: '{{ count }} Tienda encontrada',
    storesFound_other: '{{ count }} Tiendas encontradas',
    fromStoresFound: 'from {{ count }} Tienda encontrada',
    fromStoresFound_other: 'from {{ count }} Tiendas encontradas',
    findStore: 'Buscar tienda',
    useMyLocation: 'Usar mi ubicación',
    viewAllStores: 'Ver todas las tiendas',
    contactUs: 'Contáctenos',
    searchBox: 'Código postal, localidad o dirección',
    backToList: 'Volver a la lista',
    noStoresMessage: 'No se han encontrado tiendas en la base de datos...',
    geolocationNotEnabled:
      'No se pueden localizar las tiendas cercanas. No se ha habilitado el consentimiento de geolocalización',
    searchNearestStores: 'Buscar tiendas más cercanas',
    searchBoxLabel: 'Introduzca el código postal, la ciudad o la dirección',
  },
};
